import { ReactElement, useMemo } from 'react';
import { AxiosError } from 'axios';
import { EmbeddedApp } from './components/EmbeddedApp';
import { EmbeddedAppUnprocessable } from './components/EmbeddedAppUnprocessable';
import { EmbeddedAppLoader } from './components/EmbeddedAppLoader';
import { EmbeddedAppUnavailable } from './components/EmbeddedAppUnavailable';
import styles from './index.module.css';
import { determineEmbeddedAppStatus } from './components/utils/utils';

export type LaunchPanelTabContentProps = {
  error?: AxiosError;
  sessionActiveTab: SessionActiveTab;
  isLoading?: boolean;
  isError?: boolean;
  embeddedAppUrl?: string;
  refetch: VoidFunction;
  isFetching?: boolean;
};

export const LaunchPanelTabContent = ({
  error,
  sessionActiveTab,
  isError = false,
  isFetching = false,
  isLoading = true,
  embeddedAppUrl = undefined,
  refetch,
}: LaunchPanelTabContentProps): ReactElement => {
  const embeddedAppStatus = useMemo(
    () =>
      determineEmbeddedAppStatus({
        embeddedAppUrl,
        error,
        isError,
        isFetching,
        isLoading,
      }),
    [error, isError, isFetching, isLoading, embeddedAppUrl],
  );

  if (sessionActiveTab !== 'launchPanel') return <></>;

  return (
    <div className={styles.root}>
      <EmbeddedApp
        embeddedAppUrl={embeddedAppUrl}
        embeddedAppStatus={embeddedAppStatus}
      />
      <EmbeddedAppUnprocessable embeddedAppStatus={embeddedAppStatus} />
      <EmbeddedAppLoader embeddedAppStatus={embeddedAppStatus} />
      <EmbeddedAppUnavailable
        refetch={refetch}
        embeddedAppStatus={embeddedAppStatus}
      />
    </div>
  );
};
